export default __webpack_public_path__ + "static/media/Strugani 6.1c39dbd4.jpg";